import InvoiceTemplateForm from './invoice-template-form.vue';
export default InvoiceTemplateForm;
